<template>
  <div class="homeRoot">
    <!-- 顶部的图片展示 -->
    <div class="topBannerContainer">
      <el-carousel indicator-position="none" arrow="nerver" height="150px">
        <el-carousel-item v-for="(item, index) in topBannerList" :key="index">
          <img @click="handleBannerImageClick(item)" style="width: 100%; height: 100%" :src="item.images" alt="" />
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- 顶部的企业信息和菜单 -->
    <div class="topMenuContainer">
      <!-- 用户头像和企业名称 -->
      <div class="topMenuUserInfo">
        <img class="userAvatar" :src="userInfo.avatar" />
        <p class="userEnterpriseName">
          {{ userInfo.nickname }}
        </p>
        <!-- <div class="switchEnterpriseButton">切换企业 ></div> -->
      </div>
      <!-- 顶部菜单 -->
      <div class="card topMenu">
        <div @click="toPage(item)" v-for="(item, index) in topMenuList" :key="index" class="menuItem">
          <img class="menuItemIcon" :src="item.icon" />
          <p>{{ item.title }}</p>
        </div>
      </div>
    </div>
    <!-- 远程业务 -->
    <div v-for="(typeItem, typeIndex) in typeList" :key="typeIndex" class="businessTypeContainer">
      <div class="businessTypeTitle">
        <div class="titleLeftDecoration remoteBusinessTitleDecoration"></div>
        <p class="businessName">{{ typeItem.name }}</p>
      </div>
      <div class="card businessTypeItems">
        <div v-for="(innerItem, innerIndex) in typeItem.sub" :key="innerIndex" @click="toList(innerItem)">
          <div class="wrapper businessTypeItem">
            <img class="businessTypeItemBlock" :src="`${$baseUrl}${innerItem.image}`" alt="" />
            <p class="businessTypeName">{{ innerItem.name }}</p>
          </div>
        </div>
      </div>
    </div>
    <!--  -->
    <div class="businessTypeContainer">
      <div class="businessTypeTitle">
        <div class="titleLeftDecoration remoteBusinessTitleDecoration"></div>
        <p class="businessName">便民服务</p>
      </div>
      <div class="card businessTypeItems">
        <div class="businessTypeItem">
          <wx-open-launch-weapp appid="wx9d80ad24a903aa65" path="/pages/base/base?appid=bjsbghlbr">
            <script type="text/wxtag-template">
                <div stlye="display:flex;flex-direction:column;align-items:center;width:100%;">
                  <img style="width:50px;height:50px;border-radius:15px" src="http://zwxt.qilushop.cn:9001/uploads/20240927/38a07b42c7deb6f2f5cd7e56473503bb.png" alt="" />
                  <p style="white-space:norwap;color:gray;margin-top:12px;">齐鲁社保</p>
                </div>
              </script>
          </wx-open-launch-weapp>
        </div>
        <div class="businessTypeItem">
          <wx-open-launch-weapp appid="wx9d80ad24a903aa65" path="/pages/base/base?appid=lybrgwjr">
            <script type="text/wxtag-template">
                <div stlye="display:flex;flex-direction:column;align-items:center;width:100%;">
                  <img style="width:50px;height:50px;border-radius:15px" src="http://zwxt.qilushop.cn:9001/uploads/20240927/cc157102606daa7637977c9f003b6aa8.png" alt="" />
                  <p style="white-space:norwap;color:gray;margin-top:12px;">鲁医保</p>
                </div>
              </script>
          </wx-open-launch-weapp>
        </div>
        <div class="businessTypeItem">
          <wx-open-launch-weapp appid="wx9d80ad24a903aa65" path="/pages/base/base?appid=wxtsfwszybv">
            <script type="text/wxtag-template">
                <div stlye="display:flex;flex-direction:column;align-items:center;width:100%;">
                  <img style="width:50px;height:50px;border-radius:15px" src="http://zwxt.qilushop.cn:9001/uploads/20240927/80a87a304e39f598e8d0195ca74a8f62.png" alt="" />
                  <p style="white-space:norwap;color:gray;margin-top:12px;">公积金</p>
                </div>
              </script>
          </wx-open-launch-weapp>
        </div>
        <div class="businessTypeItem">
          <wx-open-launch-weapp appid="wx9d80ad24a903aa65" path="/pages/base/base?appid=sdwjwjcgdz">
            <script type="text/wxtag-template">
                <div stlye="display:flex;flex-direction:column;align-items:center;width:100%;">
                  <img style="width:50px;height:50px;border-radius:15px" src="http://zwxt.qilushop.cn:9001/uploads/20240927/7f20289c29c325213768793bfec3215a.png" alt="" />
                  <p style="white-space:norwap;color:gray;margin-top:12px;">微警务</p>
                </div>
              </script>
          </wx-open-launch-weapp>
        </div>
        <div class="businessTypeItem">
          <wx-open-launch-weapp appid="wx9d80ad24a903aa65" path="pages/base/base?appid=chwtscpub">
            <script type="text/wxtag-template">
                <div stlye="display:flex;flex-direction:column;align-items:center;width:100%;">
                  <img style="width:50px;height:50px;border-radius:15px" src="http://zwxt.qilushop.cn:9001/uploads/20240927/c22b8cef28afe4f7de66c55e11e3dd40.png" alt="" />
                  <p style="white-space:norwap;color:gray;margin-top:12px;">气象服务</p>
                </div>
              </script>
          </wx-open-launch-weapp>
        </div>
        <div class="businessTypeItem">
          <wx-open-launch-weapp appid="wx9d80ad24a903aa65" path="/pages/index/index">
            <script type="text/wxtag-template">
            <div stlye="display:flex;flex-direction:column;align-items:center;width:100%;">
              <img style="width:50px;height:50px;border-radius:15px" src="http://zwxt.qilushop.cn:9001/uploads/20230807/34d2c770a3274b946199977ee18d9814.png" alt="" />
              <p style="white-space:norwap;color:gray;margin-top:12px;">爱山东</p>
            </div>
            </script>
          </wx-open-launch-weapp>
        </div>
        <div class="businessTypeItem">
          <wx-open-launch-weapp appid="wx63a9813a3b8601d2" path="pages/mini/sacnLogin/qrlogin">
            <script type="text/wxtag-template">
            <div stlye="display:flex;flex-direction:column;align-items:center;width:100%;">
              <img style="width:50px;height:50px;border-radius:15px" src="http://zwxt.qilushop.cn:9001/uploads/20240929/9ad51a057a367ac5af3a2e32c3fdd82d.png" alt="" />
              <p style="white-space:norwap;color:gray;margin-top:12px;">营业执照</p>
            </div>
            </script>
          </wx-open-launch-weapp>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Index",
  data() {
    return {
      topMenuList: [
        {
          icon: require("../assets/images/icon_enterprise.png"),
          title: "企业信息",
          routerPath: "/enterpriseList",
        },
        {
          icon: require("../assets/images/icon_list.png"),
          title: "我的工单",
          routerPath: "/workOrder",
        },
        {
          icon: require("../assets/images/icon_user.png"),
          title: "个人中心",
          routerPath: "/user",
        },
      ],
      typeList: [],
      corporatePolicy: [
        // {
        //   name: "奖励政策",
        //   backgroundColor: "rgb(9,211,199)",
        // },
        {
          name: "优惠政策",
          backgroundColor: "rgb(93,193,32)",
          routerPath: "/enterprisePolicy",
        },
        // {
        //   name: "服务政策",
        //   backgroundColor: "rgb(246,120,43)",
        // },
      ],
      more: [
        {
          name: "邮寄地址",
          icon: require("../assets/images/icon_car.png"),
          routerPath: "/addressManagement",
        },
        {
          name: "反馈机制",
          icon: require("../assets/images/icon_feedback.png"),
        },
        {
          name: "我的评价",
          icon: require("../assets/images/icon_star.png"),
        },
        {
          name: "微网站",
          icon: require("../assets/images/icon_computer.png"),
        },
      ],
      userInfo: {},
      topBannerList: [],
      wxConfig: {}
    };
  },
  async mounted() {
    const loading = this.$loading({
      lock: true,
      text: "加载中",
      background: "rgba(255, 255, 255, 0.6)",
    });

    const url = window.location.href;
    const params = {};
    const regex = /[?&]([^=#]+)=([^&#]*)/g;
    let match;
    while ((match = regex.exec(url))) {
      params[match[1]] = match[2];
    }
    const code = params["code"];
    const state = params["state"];

    // 如果url携带有code和state 则尝试登陆
    if (code && state) {
      const loginResponse = await this.$post(
        `/addons/third/api/callback?platform=wechat&code=${code}&state=${state}`
      );

      if (loginResponse.code == 1) {
        // 全局缓存token
        window.localStorage.setItem("token", loginResponse.data.user.token);
        window.location = "https://szmp.qilushop.cn";
      } else {
        // 可能是重复登陆 先看看缓存里有没有token 有的话把页面参数去掉防止重复登陆
        if (window.localStorage.getItem("token")) {
          window.location = "https://szmp.qilushop.cn";
        } else {
          // 登陆失败
          this.$message.error({
            message: loginResponse.msg,
          });
        }
      }
    }

    // 全局缓存用户信息
    const userInfoRes = await this.$post("/api/user/userinfo");
    // 可能是401
    if (!userInfoRes) {
      loading.close();
      return;
    }

    const { data: wxConfigRes } = await this.$post("/addons/third/api/getConfig", {
      url: window.location.href
    });
    this.wxConfig = wxConfigRes;

    wx.config({
      ...this.wxConfig,
      debug: false,
      jsApiList: ["wx-open-launch-weapp"],
      openTagList: ["wx-open-launch-weapp"],
    });

    wx.ready(() => {
      console.log('wx ready');
    })

    wx.error((res) => {
      console.log('wx error', res);
    })

    document.addEventListener('WeixinOpenTagsError', function (e) {
      console.error(e.detail.errMsg); // 无法使用开放标签的错误原因，需回退兼容。仅无法使用开放标签，JS-SDK其他功能不受影响
    });

    window.localStorage.setItem(
      "userInfo",
      JSON.stringify(userInfoRes.msg /* 没写错 用户信息就是在.msg里 不在.data里 */)
    );
    this.userInfo = userInfoRes.msg;

    // 顶部的轮播图列表
    const topBannerList = await this.$post("/api/banner/list", {
      pos: "INDEX_TOP",
    });
    for (let item of topBannerList.data) {
      item.images = `${this.$baseUrl}${item.images}`;
    }
    this.topBannerList = topBannerList.data;

    //remote-business list
    const typeListRes = await this.$post("/api/government/category", {
      pid: 0,
    });

    this.typeList = typeListRes.data;

    // 不满4个一行的 填充到4个

    if (window.localStorage.getItem("cityData")) {
      loading.close();
      return;
    }

    // 省市区的数据
    const provinces = [];
    const cities = [];
    const areas = [];

    const areaRes = await this.$post("/api/common/area");
    this.updatePropertyNames(areaRes.msg);
    areaRes.msg.forEach((province) => {
      provinces.push(province);
      province.children.forEach((city) => {
        cities.push(city);
        city.children.forEach((area) => {
          areas.push(area);
        });
      });
    });
    //
    window.localStorage.setItem("cityData", JSON.stringify(areaRes.msg));
    window.localStorage.setItem("provinces", JSON.stringify(provinces));
    window.localStorage.setItem("cities", JSON.stringify(cities));
    window.localStorage.setItem("areas", JSON.stringify(areas));

    loading.close();
  },
  methods: {
    async handleBannerImageClick({ url_type, url }) {
      if (url_type == 1) {
        return window.open(url);
      }
    },
    refreshPage() {
      const currentUrl = window.location.href;
      const newUrl = currentUrl.split("?")[0];
      window.history.replaceState({}, "", newUrl);
      location.reload();
    },
    toList(innerItem) {
      const { url_type: jumpType } = innerItem;
      if (jumpType == 2) {
        return;
      }

      if (innerItem.id == 19) {
        this.$router.push("/governmentService");
        return;
      }

      if (innerItem.type == 1) {
        this.$router.push({
          path: "/contactPhoneList",
          query: { id: innerItem.id, title: innerItem.name },
        });
      } else {
        if (innerItem.jump_url) {
          window.open(innerItem.jump_url);
        } else {
          this.$router.push({
            path: "/list",
            query: { id: innerItem.id, title: innerItem.name },
          });
        }
      }
    },
    // 转换省市区的数据格式
    updatePropertyNames(arr) {
      for (let i = 0; i < arr.length; i++) {
        let obj = arr[i];
        if (obj.hasOwnProperty("childlist")) {
          obj.children = obj.childlist;
          delete obj.childlist;
        }
        if (obj.hasOwnProperty("children") && obj.children.length > 0) {
          this.updatePropertyNames(obj.children);
        } else {
          delete obj.children;
        }
      }
    },
    toPage(item) {
      this.$router.push(item.routerPath);
    },
  },
};
</script>

<style scoped>
.homeRoot {
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
}

.topBannerContainer {
  width: 100%;
  height: 170px;
  background-color: rgba(0, 0, 0, 1);
}

.topBannerContainer>>>.el-carousel__container {
  height: 170px !important;
}

.card {
  width: 95%;
  margin-top: 20px;
  border-radius: 10px;
  background-color: white;
  box-sizing: border-box;
  padding: 10px;
}

.topMenuContainer {
  width: 95%;
  position: relative;
  bottom: 40px;
  z-index: 10;
}

.topMenuUserInfo {
  height: 60px;
  background-color: rgb(248, 182, 70);
  box-sizing: border-box;
  padding: 0 5px;
  padding-bottom: 10px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  bottom: 10px;
}

.userAvatar {
  width: 35px;
  height: 35px;
  border-radius: 50%;
}

.userEnterpriseName {
  margin-left: 5px;
  font-size: 13px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 100%;
}

.switchEnterpriseButton {
  height: 30px;
  border-radius: 15px;
  background-color: rgb(53, 86, 58);
  display: flex;
  align-items: center;
  justify-items: center;
  color: rgb(250, 183, 66);
  font-size: 13px;
  margin-left: 5px;
  white-space: nowrap;
  box-sizing: border-box;
  padding: 10px;
}

.topMenu {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100px;
  margin-top: 0;
  width: 100%;
  height: 80px;
  position: relative;
  bottom: 20px;
}

.menuItem {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: gray;
  font-size: 14px;
}

.menuItemIcon {
  height: 30px;
  width: 30px;
}

.menuItem>p {
  margin: 0;
}

.businessTypeContainer {
  width: 95%;
  position: relative;
  bottom: 40px;
  margin-top: 20px;
}

.businessTypeTitle {
  color: gray;
  height: 60px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid rgb(209, 209, 209);
  width: 100%;
  background-color: white;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.titleLeftDecoration {
  height: 20px;
  width: 0px;
  border: 3px solid;
  border-radius: 10px;
  margin: 0 10px;
}

.businessName {
  font-size: 18px;
}

.remoteBusinessTitleDecoration {
  border-color: rgb(53, 183, 74);
}

.corporatePolicyTitleDecoration {
  border-color: rgb(3, 128, 246);
}

.moreTitleDecoration {
  border-color: rgb(247, 121, 44);
}

.businessTypeItems {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  margin-top: 0;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
}

.businessTypeItem_HIDDEN {
  visibility: hidden;
}

.businessTypeItemRow {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
}

.businessTypeItem {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.businessTypeItemBlock {
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 23px;
  border-radius: 15px;
  /* box-shadow: 0 0 10px 2px rgb(195, 195, 195); */
}

.businessTypeName {
  color: gray;
}

.moreIcon {
  height: 35px;
  width: 35px;
}
</style>
